import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/dailyMealsReleases`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, dailyMealsReleaseId) {
      const response = await axios.get(`${API_URL}/dailyMealsReleases/${dailyMealsReleaseId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, dailyMealsRelease) {
      const response = await axios.post(`${API_URL}/dailyMealsReleases`, dailyMealsRelease);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async replace(_, dailyMealsReleases) {
      const response = await axios.post(
        `${API_URL}/dailyMealsReleases/replace`,
        dailyMealsReleases,
      );

      if (response.status !== 201 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { dailyMealsReleaseId, dailyMealsReleaseData }) {
      const response = await axios.put(
        `${API_URL}/dailyMealsReleases/${dailyMealsReleaseId}`,
        dailyMealsReleaseData,
      );

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, dailyMealsReleaseId) {
      const response = await axios.delete(`${API_URL}/dailyMealsReleases/${dailyMealsReleaseId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getGroupedDailyMealsReleases(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/dailyMealsReleases/grouped`, {
        params: criteria,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getGroupedDailyMealsReleasesNearestGivenDate(_, date) {
      const response = await axios.get(`${API_URL}/dailyMealsReleases/grouped/nearest`, {
        params: date,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
